import _ from 'underscore';

import {
    GET_CARS,
    UPDATE_INPUT_CAR,
    DELETE_CAR,
    SUBMIT_NEW_CAR,
} from '../actions/types';

export default function (state = [], action) {
    switch (action.type) {
        case GET_CARS:
            return action.payload;
        case UPDATE_INPUT_CAR:
            return state.map(car => {
                const updateCar = action.payload;

                if (car.key === updateCar.key)
                    return _.extend(car, updateCar);
                return car;
            });
        case DELETE_CAR:
            return state.reduce((array, car) => {
                const deleteKey = action.payload;

                if (car.key !== deleteKey)
                    array.push(car);

                return array;
            }, []);
        case SUBMIT_NEW_CAR:
            return [...state, action.payload];
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/app/reducers/cars_reducer.js